const highlights = [
  { icon: "ri-award-line", title: "Certified Products", desc: "Adhering to international quality standards across all product lines." },
  { icon: "ri-global-line", title: "Global Reach", desc: "Successfully delivered projects across 10+ countries in the Middle East, Asia, and Africa." },
  { icon: "ri-building-2-line", title: "Turnkey Expertise", desc: "End-to-end hospital solutions from planning and design to installation and commissioning." },
  { icon: "ri-customer-service-2-line", title: "After-Sales Support", desc: "Dedicated technical support and maintenance services post-delivery." },
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-amber-500 mb-3">Who We Are</span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
            Trusted Healthcare
            <span className="block text-amber-500">Infrastructure Partner</span>
          </h2>
        </div>

        {/* Main Split Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/61d813d37daab83cdd3be2424ea2d0d3.jpeg"
                alt="ANDINI Medical Solutions"
                className="w-full h-[420px] object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-amber-500 text-white rounded-xl px-6 py-4 shadow-lg">
              <div className="text-3xl font-bold">2008</div>
              <div className="text-sm font-medium opacity-90">Founded in Ankara</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5">
              ANDINI LTD ŞTİ — Over 15 Years of Healthcare Excellence
            </h3>
            <p className="text-gray-600 leading-relaxed mb-5 text-base">
              Established in 2008, ANDINI LTD ŞTİ is a specialized provider of comprehensive healthcare solutions, delivering high-quality products and turnkey project services to hospitals and medical institutions worldwide.
            </p>
            <p className="text-gray-600 leading-relaxed mb-5 text-base">
              With extensive experience in the healthcare sector, ANDINI focuses on complete hospital turnkey projects, offering end-to-end solutions from planning and design to procurement, installation, and commissioning. The company is committed to supporting healthcare providers with reliable, efficient, and innovative medical infrastructure.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8 text-base">
              By partnering with leading manufacturers like Progetti, Esaote, Ibis, Smam, &nbsp;ALsa, &nbsp;CA-MI, Tecme, Devilbiss, Biolight, Novamedtek, Nuve, Tende, Nitrocare, Duman,...etc and adhering to international quality standards, ANDINI ensures the delivery of safe, modern, and effective healthcare environments — driven by a commitment to excellence and customer satisfaction.
            </p>
            <button
              onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-md font-semibold bg-gray-900 text-white hover:bg-amber-500 transition-colors duration-200 cursor-pointer"
            >
              Work With Us <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
          {highlights.map((h) => (
            <div key={h.title} className="bg-white rounded-xl p-6 border border-gray-100 hover:border-amber-200 transition-colors duration-200">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                <i className={`${h.icon} text-2xl text-amber-500`}></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">{h.title}</h4>
              <p className="text-sm text-gray-500 leading-relaxed">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
